import { useEffect } from "react";
import jwtDecode from "jwt-decode";
import type { SourceDecodedToken } from "../Types/SourceTypes";
import { getTokenEnvironment } from "../Utils/SourceEnvironment";

export const useSourceTokenSession = (token: string | null, storeExtendedSession = false) => {
  useEffect(() => {
    if (!token) {
      return;
    }
    try {
      const decoded = jwtDecode<SourceDecodedToken>(token);
      localStorage.setItem("user_id", decoded.user_id);
      localStorage.setItem("tenant_id", decoded.tenant_id);
      localStorage.setItem("role_id", decoded.role_id);
      localStorage.setItem("api_key", decoded.api_key);
      localStorage.setItem("company_name", decoded.company_name);
      if (storeExtendedSession) {
        localStorage.setItem("auth_token", token);
        const resolvedEnvironment = getTokenEnvironment(decoded);
        if (resolvedEnvironment) {
          localStorage.setItem("environment_id", resolvedEnvironment);
        }
      }

      const cleanUrl = `${window.location.origin}${window.location.pathname}`;
      window.history.replaceState({}, document.title, cleanUrl);
    } catch {}
  }, [token, storeExtendedSession]);
};
